import { render, staticRenderFns } from "./edit-textbooks.vue?vue&type=template&id=08721d3f&scoped=true&"
import script from "./edit-textbooks.vue?vue&type=script&lang=js&"
export * from "./edit-textbooks.vue?vue&type=script&lang=js&"
import style0 from "./edit-textbooks.vue?vue&type=style&index=0&id=08721d3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08721d3f",
  null
  
)

export default component.exports